import { TChannel, TConversationType } from 'src/interfaces/conversation';
import { IStore } from 'src/interfaces/store';
import { resolveAreaSender } from './resolveAreaSender';
import { TAreaSender } from './types';

interface TSenderConversation {
    channel: TChannel;
    area: string;
    store?: Partial<IStore>;
    provider?: TConversationType;
}

/**
 * Sender of a conversation from the config of its store area.
 */
export const resolveConversationSender = ({
    channel,
    area,
    store,
    provider,
}: TSenderConversation): TAreaSender =>
    resolveAreaSender(
        store?.areas?.find((item) => item.name === area) || null,
        channel,
        provider
    );
